import { useEffect, useMemo, useRef, useState } from 'react';

import { MessageType, getFixedRenewData, getFormattedResult, checkFEMessageId, isLimitedMessage, getModelName } from '@shared/store/chat';

import WaitingWave from '@/components/waiting-wave';
import ActionBar from './ActionBar';
import Enhance from './enhance';
import { RobotsMap } from '@/common/localRobot.js';
import { useParams } from 'react-router-dom';
import client from '@/store/client';
import EnhanceDs from './enhance-ds';
import MindmapV2 from '../mindmapV2';
import chatStoreManager from '@/store/chat/manager';
import navbarStore from '@/store/navbar';
import UserMessage from "./UserMessage";
import GuessAndCompare from '../guess-and-compare';
import globalStore from '@/store/global';
import tti_icon from '@/assets/img/tti_icon.png';
import { SVGPureIcon } from '@ui/svg-icon';
import FileSaver from "file-saver"
import VideoItem from './VideoItem';
import KnowledgeEnhance from './enhance-knowledge';
import { ModelType } from '@shared/constants/chat';
import Loader from '@/common/helper/loader';
import WelcomeMessage from './WelcomeMessage';
import McpItem from './mcpItem';
import AppCheckBox from '@/ui/checkbox';
import checkStore from '@/store/checkStore';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import ItemMarkdown from './ItemMarkdown';
import McpQueueLoading from './mcpItem/mcp-loading';
import useIsAiso from '@/hooks/useIsAiso';
import agentInstallStore from '@/pages/chat/components/agent-install/store'
import { InstallMcpComponent } from '@/pages/chat/components/agent-install';
import { EE } from '@/common/dependencies';

function ListItem(props) {
  const {
    msg_id,
    msg_type,
    loading = false,
    typing = false,
    status,
    role_id,
    prompt: question,
    page = [],
    search_keyword = [],
    search_total,
    refer_search,
    ask_further,
    result: answer = '',
    is_doing,
    onScrollToTop,
    role_biz,
    is_white,
    kwargs,
    stat_model,
    mind_map = "",
    tti_image,
    isAgent,
    reasoning_text,
    clone,
    code_info,
    knowledgeId,
    isMcpShare,
    kn_continue_chat,
    entrance,
    handleSend
  } = props;

  const chatStore = chatStoreManager.current;
  const { chatId, isOfficialAsstChat, lastMessage, agentInfo } = chatStore;
  const isLimited = isLimitedMessage(props);
  const modelName = getModelName(props);
  const [previewVisible, setPreviewVisible] = useState(false);
  const { id } = useParams();
  const isLastMessage = lastMessage?.msg_id === msg_id;
  const isCompleted = is_doing == 0;
  const supportCompare = ![
    "doc",
    "chat_image",
    "extract_image",
    "explain_image",
    "summary_video",
  ].includes(role_biz) && !(kwargs?.sub_process?.includes("mind"))
  const isAiso = useIsAiso();

  const lastListItemRef = useRef(null);

  const asstInfo = useMemo(() => {
    const info = navbarStore.chatModels[role_id];
    let modelInfo = {};
    // web端时从历史记录中获取信息
    if(!client.isLLQ) {
      const model = navbarStore.historyList.find(item => item.conversation_id === id);
      modelInfo = {
        ...model,
        title: model?.name,
      }
    }
    return info || RobotsMap[role_id] || modelInfo || {};
  }, [role_id, navbarStore.chatModels]);

  const knModel = useMemo(() => {
    return chatStore.historyData.kn_custom_model;
  }, [chatStore.historyData.kn_custom_model]);

  const isLocalModel = useMemo(() => {
    return !!RobotsMap[role_id]
  }, [role_id, navbarStore.chatModels]);

  const isAPIModel = useMemo(() => navbarStore.chatModels[role_id]?.chat_type === 100,
    [role_id, navbarStore.chatModels])

  const text = getFormattedResult(answer, props, isLimited);

  const isDsModel = useMemo(() => {
    // console.log('>>>role_id', role_id);
    if (role_id) {
      const {
        localModel,
        name,
        title
      } = navbarStore.chatModels[role_id] || {};
      // console.log('>>>role_id localModel', localModel);
      if (localModel) {
        return true;
      }
      if (/deepseek/i.test(name || title)) {
        return true
      }
    }
    const dsLists = globalStore.cloudConfig?.assistantRobotOnlieSet;
    if(!dsLists) return false
    return dsLists.findIndex(item => item.robot_id === role_id) >= 0
  }, [role_id, navbarStore.chatModels]);

  const statusStore = useLocalObservable(()=>({
    status: status,
    update(n) {
      this.status = n;
    }
  }));

  const handleDownload = () => {
    let filename = 'download'
    try {
      filename = tti_image.split('/').slice(-1)[0]
    } catch (error) {}
    FileSaver.saveAs(tti_image,filename)
  }

  useEffect(() => {
    if (lastListItemRef.current && !isMcpShare) {
      onScrollToTop(
        lastListItemRef.current.offsetTop,
        isCompleted ? 'instant' : 'smooth'
      );
    }
  }, [lastMessage.msg_id, isMcpShare]);

  // useEffect(() => {
  //   HelperCore.log("list-item render");
  // }, []);

  const onPaysuccess = () => {
    if(statusStore.status == -1) {
      handleRenew()
    }
  }

  useEffect(() => {
    EE.on('membership:paysuccess', onPaysuccess);
    return () => {
      EE.removeListener('membership:paysuccess', onPaysuccess)
    }
  }, [])

  useEffect(() => {
    statusStore.update(status);
  }, [status])

  /**
   * 显示搜索步骤
   * 1. 审核通过
   * 2. 有搜索词
   */
  const renderEnhancement = () => {
    if (
      (status != -1) &&
      (search_keyword?.length > 0 || refer_search?.length)
    ) {
      return (
        <Enhance
          messageId={msg_id}
          messageItem={props}
          // folded={isCompleted || answer.length > 50}
          folded={true}
          isCompleted={isCompleted}
          chatStore={chatStore}
          asstInfo={modelName}
          flows={{
            search_keyword,
            search_total,
            refer_search,
          }}
        />
      );
    }

    return null;
  };

  const handleRenew = () => {
    if(isMcpShare && HelperCore.isPhone()){
      globalStore.navigate("/");
      return;
    }

    const messageItem = chatStore.messageMap.get(msg_id);
    const { is_retry, role_id, compare_parent_id, generate_type, parent_msg_id } = messageItem;
    chatStore.sendMessage({
      renew: !checkFEMessageId(msg_id),
      retry: is_retry,
      messageId: checkFEMessageId(msg_id) ? undefined : msg_id,
      asstId: role_id,
      input: question,
      compare_parent_id,
      html_message_id: parent_msg_id,
      generate_type,
      ...getFixedRenewData(messageItem),
    });
  }

  if (msg_type === MessageType.ClearContext) {
    return (
      <li className="py-12px flex items-center">
        <span
          style={{
            background:
              'linear-gradient(270deg,rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 100%)',
          }}
          className="h-[1px] flex-1"
        ></span>
        <span className="px-[16px] text-[12px] text-[#bdbdbd]">
          已清除上下文
        </span>
        <span
          style={{
            background:
              'linear-gradient(270deg, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%)',
          }}
          className="h-[1px] flex-1"
        ></span>
      </li>
    );
  }

  // 无效消息，脏数据
  if(isAgent || chatStore.mcpStore.isMcpAgent || chatStore.mcpStore.isAgentFlow) {}
  else {
    if(!role_id){
      return null;
    }
  }

  const should_generate_mindmap = ((role_biz == "mind" ||  role_biz == "page_mind") && is_white != 1);

  // debug
  // console.warn("listitem asstInfo:", {role_id}, HelperCore.copyObj(asstInfo), ModelType)

  const isMcpServer = chatStore.lastMessage?.cloud_mcp?.length > 0 || chatStore.lastMessage?.mcp?.length > 0;

  return (
    <li
      ref={isLastMessage ? lastListItemRef : null}
      style={{
        minHeight: isLastMessage && !isMcpShare ? 'calc(100vh - 290px)' : 'max-content',
      }}
      className={['py-12px flex flex-col gap-24px', isAiso ? '' : 'first-of-type:pt-24px']}
      data-id={msg_id}
      data-biz={role_biz}
    >
      <UserMessage {...props} />
      {chatStore.lastMessage.msg_type === MessageType.Welcome
      ? (
        <WelcomeMessage
          msg_type={msg_type}
          messageId={msg_id}
          isAgent={isAgent}
          isLocalModel={isLocalModel}
          asstInfo={asstInfo}
          agentInfo={agentInfo}
        />
      ) : (agentInstallStore.show && !agentInstallStore.installed)
      ? <div className='w-full pr-6px flex flex-col items-center pl-12px pr-10px'>
          <div className='w-full sm:max-w-776px'>
            <InstallMcpComponent />
          </div>
        </div>
      :
      (
      <section className={`
        message-item-section
        flex flex-col gap-[8px] relative  ${isAiso ? 'pt-4px pb-10px' : 'py-10px'} rounded-16px
        ${(checkStore.getChecked(`${msg_id}-r`) && !clone) ? "bg-[rgba(0,0,0,0.03)]" : ""}
      `}>
        {
          checkStore.data.isShowCheck && !clone
          ? <AppCheckBox
              className="absolute top-16px -left-24px cursor-pointer w-16px h-16px"
              checked={checkStore.getChecked(`${msg_id}-r`)}
              onClick={() => {
                const checked = checkStore.getChecked(`${msg_id}-r`)
                checkStore.setChecked(`${msg_id}-p`, !checked)
                checkStore.setChecked(`${msg_id}-r`, !checked)
                if(checkStore.data.checkList.length < 2 * chatStore.messageList.length) return
                checkStore.setData({
                  allChecked: checkStore.data.checkList.every(item => item.checked)
                })
              }}
            />
          : null
        }
        {
          chatStore.modelInfo && !isAiso && !chatStore.mcpStore.agentInfo
          ? (
            <div className="flex gap-[8px] flex items-center">
              <div className={`relative rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)] size-24px`}>
                <img className={`rounded-6.5px object-cover size-24px`} src={
                  Loader.getModelIcon(chatStore.modelInfo)
                } />
                {asstInfo?.conversation_type == 1 ? (
                  <img
                    className="size-12px object-cover absolute left-0 bottom-0"
                    src={tti_icon}
                  />
                ) : null}
              </div>
              <strong className="text-[16px] font-medium leading-snug">
                {
                  chatStore.modelInfo.title
                }
              </strong>
              {
                knModel && knModel.title && !knModel.title.includes("默认")
                ? (
                  <div className="h-18px rounded-4px bg-black bg-opacity-3 leading-18px text-12px text-black text-opacity-50 px-6px">
                    {knModel.title}
                  </div>
                )
                : null
              }
              {
                role_id && isLocalModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#0058FF] bg-[#0058FF] bg-opacity-10 rounded-4px inline-block">本地</span>
                )
              }
              {
                role_id && asstInfo?.model_type === ModelType.APIModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#E43F9F] bg-opacity-10 bg-[#E43F9F] rounded-4px inline-block">API</span>
                )
              }
              {
                role_id && asstInfo?.model_type === ModelType.PrivateModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#ff7307] bg-[#ff7307] bg-opacity-10  rounded-4px inline-block">私有</span>
                )
              }
            </div>
          )
          : null
        }
        {
          !clone && status != -1
          ? <KnowledgeEnhance messageId={msg_id} messageItem={props} />
          : null
        }
        {!should_generate_mindmap && !isDsModel && !globalStore.globalConfig.supportAllRobotOnline && !isAgent && !clone && status != -1 && renderEnhancement()}
        {(isDsModel || globalStore.globalConfig.supportAllRobotOnline || isAgent) && msg_type !== MessageType.Welcome && !clone && status != -1 && !isAiso ? <EnhanceDs
          messageId={msg_id}
          messageItem={props}
          folded={false}
          chatStore={chatStore}
          asstInfo={modelName}
          isAgent={isAgent}
        />: null}
        {loading ? (
          isAgent || reasoning_text
          ? null
          : chatStore.mcpStore.isAgent
          ? <McpQueueLoading chatStore={chatStore} isLastMessage={isLastMessage} messageItem={{...props}} />
          : <WaitingWave color={globalStore.isDark ? "rgba(255,255,255,.2)" : "rgba(0,0,0,.2)"} />
        ) : (
          <>
            <div className={["flex flex-col gap-[24px] message-item-content", {'group':  isCompleted && !isLastMessage}]}>
              {
                (role_biz == "ai_agent" || role_biz == "ai_agent_flow") && (chatStore.mcpStore.isMcpAgent || chatStore.mcpStore.isAgentFlow || isMcpServer) && status != -1 && is_white != 1
                ? <McpItem messageItem={{...props}} chatStore={chatStore} isLastMessage={isLastMessage} onRenew={handleRenew} handleSend={handleSend} />
                : role_biz == "summary_video"
                ? (
                  <VideoItem {...props} />
                )
                : (
                  <>
                    {
                      (should_generate_mindmap && (mind_map || !isCompleted))
                      ? (
                        <div className='w-600px'>
                          <MindmapV2
                            mindmap={mind_map || ""}
                            page={page || []}
                            prompt={question}
                          />
                        </div>
                      )
                      : null
                    }
                    {tti_image ? (
                      <div className="w-390px h-390px rounded-16px border-1px border-[rgba(0,0,0,0.05)] overflow-hidden relative">
                        {previewVisible ? (
                          <div
                            className="preview-image-mask fixed inset-0 bg-black/80 z-1000"
                            onClick={() => {
                              setPreviewVisible(false);
                            }}
                          >
                            <div className="w-full h-full flex items-center justify-center">
                              <img className="object-contain max-w-[calc(100%-32px)] max-h-90vh" src={tti_image}></img>
                            </div>
                          </div>
                        ) : null}
                        <img
                          className="object-cover"
                          width={390}
                          src={tti_image}
                          onClick={() => {
                            setPreviewVisible(true);
                          }}
                        ></img>
                        <div
                          className="size-24px absolute left-16px top-16px bg-[rgba(0,0,0,0.5)] hover:bg-[rgba(0,0,0,0.8)] rounded-6px cursor-pointer z-1 flex items-center justify-center"
                          onClick={handleDownload}
                        >
                          <SVGPureIcon
                            name="tti_download"
                            size={14}
                            color={'#ffffff'}
                          />
                        </div>
                      </div>
                    ) : null
                    }
                    {
                      !should_generate_mindmap && !tti_image
                      ? (
                        <ItemMarkdown
                          typing={typing}
                          text={text}
                          codeInfo={code_info}
                          isCompleted={isCompleted}
                          messageId={msg_id}
                          {...props}
                        />
                      )
                      : null
                    }
                  </>
                )
              }

              {msg_type !== MessageType.Welcome && status != -1 && !clone && !isMcpShare ? (
                <ActionBar
                  className={[
                    {
                      invisible: !isCompleted || !isLastMessage,
                      'group-hover:visible': isCompleted && !isLastMessage,
                    },
                  ]}
                  renewable={isLastMessage && !isAPIModel}
                  answer={answer}
                  msg_id={msg_id}
                  chatId={chatId}
                  prompt={question}
                  messageItem={chatStore.messageMap.get(msg_id)}
                  isAgentWelcome={isAgent && msg_type === MessageType.Welcome}
                  onRenew={handleRenew}
                />
              ) : null}

              {(!should_generate_mindmap && isCompleted && isLastMessage && status != -1 && !tti_image) && !clone && !checkStore.data.isShowCheck && !isMcpShare && (
                <>
                  <GuessAndCompare
                    chatId={chatId}
                    messageId={msg_id}
                    asstInfo={asstInfo}
                    ask_further={ask_further}
                    excludeModelId={lastMessage.role_id}
                    supportCompare={supportCompare}
                    knowledgeId={knowledgeId}
                    kn_continue_chat={kn_continue_chat}
                    entrance={entrance}
                  />
                </>
              )}
            </div>
          </>
        )}
      </section>
      )}
    </li>
  );
}

export default observer(ListItem);
